// extracted by mini-css-extract-plugin
export default {"date":"Time_date__+q1ji"};